var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L12.3374 4.83579L18 6.49342L14.4 11.1397L14.5623 17L9 15.0358L3.43769 17L3.6 11.1397L0 6.49342L5.66262 4.83579L9 0Z",
    fill: "#FFE9C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V15.0358L3.43769 17L3.6 11.1397L0 6.49342L5.66262 4.83579L9 0Z",
    fill: "#FFB833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStarIcon);
export default __webpack_public_path__ + "static/media/half-star-icon.73e8e1812b919929b872e7b5aecc7d9d.svg";
export { ForwardRef as ReactComponent };